import { render } from "./PropertyList.vue?vue&type=template&id=6d650327"
import script from "./PropertyList.vue?vue&type=script&lang=js"
export * from "./PropertyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__